
import './App.css';
import Navigation from'./components/Navigation/Navigation';
import Logo from './components/Logo/Logo';
import ImageUrlInput from './components/ImageUrlInput/ImageUrlInput';
import ParticlesBg from 'particles-bg'
import { Component } from 'react';

import ImageDisplay from './components/ImageDisplay/ImageDisplay';
import Signin from './components/Signin/Signin';
import Register from './components/Register/Register';
import Rank from './components/Rank/Rank'


const USER_ID = 'ramz07';
// Your PAT (Personal Access Token) can be found in the portal under Authentification
const PAT = '884649d220e4483e91f254c5a197ecb1';
const APP_ID = 'my-first-application';
// Change these to whatever model and image URL you want to use
const MODEL_ID = 'face-detection';
const MODEL_VERSION_ID = '6dc7e46bc9124c5c8824be4822abe105';  



    


const initialState = {
  image:'',
  searchfield:'',
  box:'',
  route:'signin',
  isSigned:false,
  user:{
      id:"",
      name:"",
      email:"",
      entries:0,
      joined:""
    }
}
class App extends Component {
  
    constructor(){
      super();
      this.state=initialState;
      this.onIPchange.bind(this);
  }

  onDetect=()=>{
    fetch('https://facedetection-backend-ramsundar07.onrender.com/image', {
      method:'put',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        id: this.state.user.id
      })
    }).then(r=>r.text())
    .then(entries=>this.setState(Object.assign(this.state.user,{entries:entries})));
  }


  updateUser=(data)=>{
    console.log("=>",data);
    this.setState({user:{
      id:data.id,
      name:data.name,
      email:data.email,
      entries:data.entries,
      joined:data.joined
    }})
    
        
  }

  

  findBox=(da)=>{
    // const da = JSON.parse(d);
    // const da =d;
    console.log(da)
    const b =da['outputs'][0].data.regions[0].region_info.bounding_box;
    const img = document.getElementById('faceimg');
    const width = img.width;
    const height = img.height;
    return{
        leftCol: b.left_col * width,
        topRow: b.top_row * height,
        rightCol: width - (b.right_col * width),
        bottomRow: height - (b.bottom_row * height) 
    }
  }



  displayBox=(b)=>{
    this.setState({box:b})
  }

  onIPchange=(event)=>{
    this.setState({image:event.target.value})
    if(!event.target.value)
      this.setState({box:""})
  }


  changeRoute = (r)=>{
    if(r==="home"){
      this.setState({isSigned:true,image:""})
    }
    else{
    
      this.setState({name:"",entries:"",isSigned:false,image:"",box:""})
    }
    this.setState({route:r})
    console.log("route",this.state.route,this.state.isSigned)
  }


  onBTNclick=(event)=>{
  
    // const raw = JSON.stringify({
    //     "user_app_id": {
    //         "user_id": USER_ID,
    //         "app_id": APP_ID
    //     },
    //     "inputs": [
    //         {
    //             "data": {
    //                 "image": {
    //                     "url": this.state.image
    //                 }
    //             }
    //         }
    //     ]
    // });
  
    // const requestOptions = {
    //     method: 'POST',
    //     headers: {
    //         'Accept': 'application/json',
    //         'Authorization': 'Key ' + PAT
    //     },
    //     body: raw
    // };
  
    // fetch("https://api.clarifai.com/v2/models/" + MODEL_ID + "/versions/" + MODEL_VERSION_ID + "/outputs", requestOptions)
    
    //     .then(response => response.text())
          fetch('https://facedetection-backend-ramsundar07.onrender.com/imageapi', {
            method:'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              image: this.state.image
            })
          })
          .then(response=>response.json())
          .then(result => this.displayBox(this.findBox(result)))
          .then(this.onDetect())
          .catch(error => console.log('error', error));

          this.setState({searchfield:this.state.image})


      
  }
  render(){
    console.log("Entries",this.state.user.entries)
    return (
      <div className="App">
        
        <ParticlesBg type="cobweb" bg={true} className='particles' />
        <Navigation changeRoute={this.changeRoute} isSigned={this.state.isSigned}/>
        <Logo/>
        {this.state.route==='signin'?
        <Signin changeRoute={this.changeRoute} updateUser={this.updateUser}/>
        :(this.state.route=='reg'?<Register changeRoute={this.changeRoute} updateUser={this.updateUser}/>
        :<div>
        <Rank name ={this.state.user.name} entries={this.state.user.entries}/>
        <ImageUrlInput onIPchange={this.onIPchange} onBTNclick={this.onBTNclick}/>
        <ImageDisplay url={this.state.image} box={this.state.box}/>
        </div>
        )
      }
      </div>
    );
  }
}

export default App;
